/*
 *  Featured Products
 *    Scripts for the featured products carousel
 *
 *  Version:
 *    1.0.0 - 2022/02/17
 */

import { CLASS_INITIALISED } from '../../tools/constants/classes';
import { initCarousel, InitCarouselParams } from '../../objects/carousel';
import { responsiveQuery } from '../../settings/responsive';

const SELECTOR_CONTAINER = '[data-featured-products]';
const SELECTOR_CAROUSEL = '[data-featured-products-carousel]';
const SELECTOR_NAV = '[data-featured-products-nav]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    // Check if section has already been initialized
    if (container.classList.contains(CLASS_INITIALISED)) return;
    container.classList.add(CLASS_INITIALISED);

    const carouselElement =
      container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
    const nav = container.querySelector<HTMLElement>(SELECTOR_NAV);
    const options = {
      slides: {
        perView: 1.5,
        spacing: 24,
        origin: 'center' as const,
      },
      loop: true,
      breakpoints: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '(min-width: 550px)': {
          slides: {
            perView: 1.8,
            spacing: 24,
            origin: 'center' as const,
          },
        },
        [responsiveQuery('SMALL')]: {
          slides: {
            perView: 2.4,
            spacing: 24,
            origin: 'center' as const,
          },
        },
        [responsiveQuery('MEDIUM')]: {
          slides: {
            perView: 2.9,
            spacing: 24,
            origin: 'center' as const,
          },
        },
        [responsiveQuery('LARGE')]: {
          slides: {
            perView: 3.3,
            spacing: 32,
            origin: 'center' as const,
          },
        },
        [responsiveQuery('XLARGE')]: {
          slides: {
            perView: 3.65,
            spacing: 32,
            origin: 'center' as const,
          },
        },
      },
    };
    if (!carouselElement) return;

    const params: InitCarouselParams = {
      container: carouselElement,
      navigationContainer: nav,
      options,
    };
    const carousel = initCarousel(params);
  });
